import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { promoCodeService } from '../promoCodeService';
import { IValidatePromoCodeRequest, IValidatePromoCodeResponse } from '../promoCodeTypes';

export const useValidatePromoCode = () => {
  return useMutation<IValidatePromoCodeResponse, AxiosError, IValidatePromoCodeRequest>({
    mutationFn: (payload) => promoCodeService.validatePromoCode(payload),
  });
};
